import {MMQueryOptions} from 'lionheartland';


export class SODeleteEntityPermission {

  constructor(
    public uid: string,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
}
